import React, { Component } from 'react';
import Button from '../Button';
import FontAwesomeIcon from '../Icon';
import MaintenanceGuideForm from '../MaintenanceGuideForm';
import Overlay from '../Overlay';
import Search from '../Search';
import Actions from '../Actions';
import MaintenanceGuiddeRepeater from './MaintenanceGuideRepeater';
import Empty from '../Empty';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setFndFormData, clearFndFormData } from '../../store/actions/fndForm';
import { selectSearch } from '../../store/selectors/search';
import ContentBlock from '../ContentBlock';
import { IntroContent, USER_ROLES } from '../../common/constants';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import '../NoteFormNewLocalState/Notes.scss';

class MaintenanceGuides extends Component {
  state = {
    showOverlay: false,
  };

  onEditMaintenanceGuide = async (maintenanceguide) => {
    const { setFndFormData, clearFndFormData } = this.props;
    await clearFndFormData();
    if (maintenanceguide.appointment) {
      let date = new Date(maintenanceguide.appointment.date);
      let time =
        maintenanceguide.appointment.time && maintenanceguide.appointment.time
          ? new Date(maintenanceguide.appointment.time)
          : null;
      let appointment = {
        date,
        time,
      };
      maintenanceguide = { ...maintenanceguide, appointment, toggle: true };
    }
    setFndFormData(maintenanceguide);
    this.setState({ showOverlay: true });
  };
  render() {
    const {
      from,
      maintenanceguides,
      onlyView,
      onSaveMaintenanceGuide,
      onDeleteNote,
      breadcrumb,
      onSearch,
      setFndFormData,
      clearFndFormData,
      search,
      introContent,
      user,
    } = this.props;
    const { showOverlay } = this.state;
    return (
      <div className="notes">
        {/**
         * Created By: Sai Prasad
         * Created Date: 29/09/2022
         * Jira Ticket: JUN-3214
         * Description: Intro content to MaintenanceGuide Tab under suite.
         */}
        {introContent && (
          <ContentBlock content={IntroContent.maintenanceReminders} />
        )}
        <Actions compact>
          <Search
            size="small"
            placeholder="Maintenance Reminders..."
            onChange={onSearch}
          />
          {onlyView === true ? null : (
            <Button
              color="teal"
              label="Add Maintenance Reminders"
              onClick={() => {
                clearFndFormData();
                this.setState({ showOverlay: true });
              }}
              icon={
                <FontAwesomeIcon glyph="edit" weight="light" size="small" />
              }
              size="small"
            />
          )}
        </Actions>
        {maintenanceguides.length > 0 ? (
          <>
            <MaintenanceGuiddeRepeater
              from={from}
              onlyView={onlyView}
              maintenanceguides={maintenanceguides}
              onEdit={(maintenanceguide) =>
                this.onEditMaintenanceGuide(maintenanceguide)
              }
              onDelete={(maintenanceguide) =>
                window.confirm(
                  `Are you sure you want to delete ${maintenanceguide.title}?`
                ) && onDeleteNote(maintenanceguide)
              }
            />
          </>
        ) : (
          <Empty
            headline="No Maintenance Reminders Added yet"
            strapline="You can use the Maintenance Reminders section to post any status updates or general comments to keep everyone on the same page."
            searchIsActive={
              search && search.maintenanceguides ? search.maintenanceguides : ''
            }
            cta={
              onlyView === true ? null : (
                <Button
                  color="teal"
                  label="Add Maintenance Reminders"
                  onClick={() => {
                    clearFndFormData();
                    this.setState({ showOverlay: true });
                  }}
                  icon={
                    <FontAwesomeIcon glyph="edit" weight="light" size="small" />
                  }
                  size="small"
                />
              )
            }
            image={
              <img
                alt="No Maintenance Reminders yet"
                src="/assets/empty/notes.svg"
              />
            }
          />
        )}
        <Overlay
          showOverlay={showOverlay}
          content={
            <MaintenanceGuideForm
              breadcrumb={breadcrumb}
              onSaveMaintenanceGuide={onSaveMaintenanceGuide}
              onClose={() =>
                this.setState({ showOverlay: false }, () => clearFndFormData())
              }
            />
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  search: selectSearch(state),
  user: selectAuthenticatedUser(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setFndFormData,
      clearFndFormData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceGuides);
